<template>
  <template v-for="fieldError in fieldErrors">
    <div
      v-if="
        fieldError.error &&
        fieldError.field &&
        fieldError.field === inputFieldName
      "
      :key="fieldError.field + fieldError.error"
      class="invalid-feedback clear-both"
    >
      {{ capitaliseFirstLetter(fieldError.error) }}
    </div>
  </template>
</template>

<script setup lang="ts">
import type { FieldError } from "~/model/api/pLCnextStoreFrontendAPI.schemas";

defineProps({
  fieldErrors: {
    type: Array as () => FieldError[],
    default: () => [],
  },
  inputFieldName: {
    type: String,
    required: true,
  },
});

const capitaliseFirstLetter = (s: string) =>
  s.charAt(0).toUpperCase() + s.slice(1);
</script>
